import { render, staticRenderFns } from "./OEContact.vue?vue&type=template&id=183dc570&"
import script from "./OEContact.vue?vue&type=script&lang=js&"
export * from "./OEContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports